<template>
  <Icon
    v-if="name"
    :mode
    :customize
    :size="icon_size"
    :name="`${prefix}:${name}`"
  />
</template>

<script setup lang="ts">
import type { UIconsProps } from "~/types/schemas/common/Atom/icon";

const props = withDefaults(defineProps<UIconsProps>(), {
  mode: "css",
  prefix: "i",
  icon_size: "24px",
});

// Define the customize function to modify SVG content
const customize = (content: string) => {
  if (!props.strokeWidth) return content;

  return content.replace(
    /stroke-width="[^"]*"/g,
    `stroke-width="${props.strokeWidth}"`,
  );
};
</script>
